<div class="head-container" [ngClass]="{ dark: theme === 'dark' }">
  <div class="context-container">
    <div class="title-icon">
      <img [src]="icon" alt="" class="arrow" />
    </div>
    <p class="banner-title">{{ title }}</p>
  </div>
  <a *ngIf="navigationUrl" class="nav-container" [routerLink]="[navigationUrl]">
    <div class="nav-title">See All</div>
    <div class="nav-icon">
      <img
        src="/assets/images/icons/right-blue-arrow.svg"
        alt=""
        class="arrow"
      />
    </div>
  </a>
</div>
